export const openAuthDialog = (authType, trkLocation, onSuccessActions) => {
  window?.nwapi?.ui?.showAuthDialog({
    authType,
    version: 2,
    trk: {
      trk_location: trkLocation,
    },
    onSuccess: () => {
      onSuccessActions();
    },
  });
};
